/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnExerciseToolType } from './en-exercise-tool-type';
 /**
 *
 *
 * @export
 * @interface ScreeningToolDto
 */
export interface ScreeningToolDto {

    /**
     * Tool type. Use WEIGHT for a gym load in kg.
     *
     * @type {EnExerciseToolType}
     * @memberof ScreeningToolDto
     */
    type: EnExerciseToolType;

    /**
     * Load value (integer). For WEIGHT: kilograms.
     *
     * @type {number}
     * @memberof ScreeningToolDto
     */
    value: number;
}
